module.exports = __webpack_public_path__ + "static/img/default.f66dfe7c.png";